/**
 * Codec emoji — base-1024, 10 bits por simbolo.
 *
 * Expansao: cada 10 bits viram um emoji de 4 bytes em UTF-8, ou seja ~3,2x
 * o tamanho do payload em bytes transmitidos. E o codec mais chamativo dos
 * tres; serve para conversas curtas onde parecer uma brincadeira ajuda.
 */
import { EMOJI_ALPHABET } from './emoji-alphabet.js'
import { fromSymbols, stripLengthPrefix, toSymbols, withLengthPrefix } from './bitstream.js'
import { randomInt, randomPick } from './random.js'
import { DisguiseError } from './types.js'

export const EMOJI_BITS = 10
export const EMOJI_BASE = 1 << EMOJI_BITS

const INDEX_BY_EMOJI = new Map<string, number>(EMOJI_ALPHABET.map((e, i) => [e, i]))

/** Separadores sem informacao: so quebram o bloco para nao virar um paredao. */
const SEPARATORS = [' ', '  ', '\n'] as const

export function encodeEmoji(payload: Uint8Array): string {
  const symbols = toSymbols(withLengthPrefix(payload), EMOJI_BITS)
  let out = ''
  let untilBreak = 3 + randomInt(6)
  for (let i = 0; i < symbols.length; i++) {
    out += EMOJI_ALPHABET[symbols[i] ?? 0] ?? ''
    untilBreak -= 1
    if (untilBreak === 0 && i < symbols.length - 1) {
      out += randomPick(SEPARATORS)
      untilBreak = 3 + randomInt(6)
    }
  }
  return out
}

export function decodeEmoji(text: string): Uint8Array {
  const symbols: number[] = []
  // Iterar por ponto de codigo, nao por unidade UTF-16.
  for (const char of text) {
    if (/\s/u.test(char)) continue
    const index = INDEX_BY_EMOJI.get(char)
    if (index === undefined) throw new DisguiseError(`simbolo fora do alfabeto emoji: ${char}`)
    symbols.push(index)
  }
  if (symbols.length === 0) throw new DisguiseError('texto emoji vazio')
  return stripLengthPrefix(fromSymbols(symbols, EMOJI_BITS))
}

/** `true` se o texto so tem emojis do alfabeto (e espacos). Usado na deteccao. */
export function looksLikeEmoji(text: string): boolean {
  let seen = 0
  for (const char of text) {
    if (/\s/u.test(char)) continue
    if (!INDEX_BY_EMOJI.has(char)) return false
    seen += 1
  }
  return seen > 0
}
